import { DeviceAvailableMeasure } from '@weenat/client/dist/resources'
import { isNil } from 'lodash-es'
import { memo } from 'react'
import Icons from '../Icons'
import Text from '../Text'
import OpenRipple from './OpenRipple'

interface NoEmissionEmptyStateProps {
  IconName?: keyof typeof Icons
  title?: string
  description?: string
  metrics?: DeviceAvailableMeasure[]
}

const NoEmissionEmptyState: FC<NoEmissionEmptyStateProps> = ({
  IconName = 'SingleSensorFilled',
  title,
  description,
  metrics,
  children
}) => {
  const Icon = Icons[IconName]

  return (
    <Flex
      $flex={1}
      $flexDirection='column'
      $alignItems='center'
      $justifyContent='center'
      $p='lg'
      $gap={'md'}
    >
      <OpenRipple metrics={metrics}>
        <Icon $size='xl' $color={'grayscale.700'} />
      </OpenRipple>
      <Flex $flexDirection='column' $gap={'sm'}>
        {!isNil(title) ? (
          <Text $fontWeight='bold' $textAlign='center'>
            {title}
          </Text>
        ) : null}
        {!isNil(description) ? <Text $textAlign='center'>{description}</Text> : null}
      </Flex>
      {children}
    </Flex>
  )
}

export default memo(NoEmissionEmptyState)
